import { useEffect, useState } from 'react';

/** 计算rem的比例,用于某些需要根据这个比例设定尺寸的场景 */
export const usePx2RemRate = () => {
  const [rate, setRate] = useState(1);
  useEffect(() => {
    const onResize = () => {
      setRate(parseFloat(document.documentElement.style.fontSize) / 36);
    };
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return rate;
};
